export default [{
  path: '/department',
  name: 'department',
  meta: {
    layout: "main",
    public: false
  },
  component: () => import('@/views/department/index')
}]
